module.exports = __webpack_public_path__ + "media/promo/panasonic/images/buy-3-bb4d71452a27f794ac80e1ed0366e110.png";